import { createAsyncThunk } from '@reduxjs/toolkit';
import { BILLING_ROUTES } from '@custom/Utils/constants/apiUrls';

const editDoctorDiscountApi = createAsyncThunk('editDoctorDiscount', async (body:any) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      let url = BILLING_ROUTES.DOCTOR_DISCOUNT.edit;
      let response = await fetch(url, {
        method: 'PUT',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body:JSON.stringify(body)
      });

      if (!response.ok) {
        throw new Error('Failed to edit doctor discount');
      }

      return await response.json();
    } catch (error) {
      return Promise.reject(error);
    }
  });

export default editDoctorDiscountApi;
